import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { position } from 'polished';
import fp from 'lodash/fp';
import transition from 'styled-transition-group';
import {
  getLayer,
  size,
  media,
  color,
  host,
} from '@deerplusofficial/pos-helper';
import {
  Alert,
  ButtonBase as Button,
  Icon,
} from '@deerplusofficial/pos-components';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';
import actions from '../../actions';
import { channelShape } from '../../model/Types';
import Image from '../../components/Image/Image';
import MenuCell, { Container as MenuCellContainer } from './MenuCell';

const Container = transition.div.attrs({
  timeout: 400,
  mountOnEnter: true,
  unmountOnExit: true,
})`
  display: flex;
  flex-direction: column;
  width: 312px;
  background-color: #323237;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  z-index: ${getLayer('drawer')};
  transition: transform 0.4s ease-in-out 0s;
  ${position('absolute', '0', null, '0', '0')};
  &:enter {
    transform: translate(calc(-100% - 4px), 0) ;
  }
  &:enter-active,
  &:exit {
    transform: translate(0);
  }
  &:exit-active {
    transform: translate(calc(-100% - 4px), 0) ;
  }
`;

const Topbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  width: 313px;
  height: ${size.topbar.mobile};
  font-size: 18px;
  background-color: #27272a;
  ${media(
    'tablet',
    css`
      height: ${size.topbar.tablet};
    `
  )};
`;

const ToggleIcon = styled(Icon).attrs({ icon: 'bars' })`
  margin-left: 10px;
  color: ${color.text.title};
`;

const Avatar = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Photo = styled(Image)`
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
`;

const Menu = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

const MenuButton = MenuCellContainer;

const BottomMenu = styled.div`
  margin-top: auto;
`;

class Drawer extends React.PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    channel: channelShape,
    toggleDrawer: PropTypes.func,
    client: PropTypes.shape({}),
  };

  static defaultProps = {
    active: false,
    channel: {},
    toggleDrawer: fp.identity,
    client: {},
  };

  onLogoutClick = async () => {
    const {
      history,
      pathTo,
      client: { onLogoutPointOfSale, posId },
    } = this.props;

    await onLogoutPointOfSale(posId);

    history.push(pathTo.login);
  };

  onToAdminClick = async () => {
    const {
      client: { onLogoutPointOfSale, posId },
    } = this.props;

    const { value: payload } = await Alert({
      titleText: '您將要離開 POS 前往營運總覽\n是否要登出 POS ？',
      type: 'question',
      showCancelButton: true,
      preConfirm: () => onLogoutPointOfSale(posId),
    });

    if (!payload) return;

    window.location.href = host.admin;
  };

  render() {
    const {
      active,
      toggleDrawer,
      pathTo,
      channel: { logo, name },
    } = this.props;

    return (
      <Container in={active}>
        <Button onClick={toggleDrawer}>
          <Topbar>
            <Avatar>
              {logo && <Photo src={logo} size={30} />}
              {name}
            </Avatar>
            <ToggleIcon />
          </Topbar>
        </Button>
        <Menu>
          <MenuCell to={pathTo.main}>POS 系統</MenuCell>
          <MenuCell to={pathTo.orders}>店頭訂單</MenuCell>
          <MenuButton onClick={this.onToAdminClick}>營運總覽</MenuButton>
        </Menu>
        <BottomMenu>
          <MenuButton onClick={this.onLogoutClick}>離開 POS</MenuButton>
        </BottomMenu>
      </Container>
    );
  }
}

const { toggle: toggleDrawer } = actions.drawer;

export default fp.compose(
  withRouter(),
  withClient(),
  connect(
    ({ drawer, channel }) => ({ channel, active: drawer.active }),
    { toggleDrawer }
  )
)(Drawer);



// WEBPACK FOOTER //
// ./src/components/Drawer/Drawer.js